<div class="flex flex-col gap-4 max-w-7xl mx-auto">

  <app-data-table 
    [columns]="cfiListColumns"
    [data]="cfiRows"
    [url]="'/master/cfi-master/'"
    [showCheckbox]="true"
    [selectionMode]="'multiple'"
    (onSelectionChange)="onSelectionChange($event)"
    [additionalHeaderButtons]="additionalButtons"
    (onAdditionalButtonClick)="showIndigenisationPopup=true"
    [title]="title"
    [showAddButton]="true"
    [isDeletable]="true"
    (onAdd)="showDialog = true"
    [isEditable]="true"
    (editEventRow)="editCfi($event)"
    (deleteEventRow)="showDeletePopup($event)"
  >
  </app-data-table>
</div>





<p-dialog header="Delete CFI" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete CFI ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteCfi()" class="mt-2">
    </p-button>
  </div>
</p-dialog>

<p-dialog header="CFI Bulk Upload " [(visible)]="showDialog" [modal]="true" [style]="{width: '60vw'}" [closable]="true" [dismissableMask]="true">
    <ng-template pTemplate="content">
      <div class="flex justify-end mt-2">
        <button 
          type="button" 
          class="px-3 py-1.5 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition"
          (click)="downloadCSV()"
          title="Download CSV"
        >
          <i class="pi pi-download mr-1 text-blue-700"></i> Simple CSV
        </button>
      </div>
      <form [formGroup]="createForm" class="w-full px-4 pb-2">
        <div class="grid grid-cols-1 gap-4">
          <!-- Indent No. and Attachment in one row for md and up, stacked for small screens -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            <div>
              <label class="block font-semibold text-sm text-blue-600 mb-1" for="fileInput">Attachment (.csv):</label>
              <input 
                type="file" 
                (change)="onFileChange($event)"
                id="fileInput"
                accept=".csv,.xlsx,.xls"
                class="w-full border-2 border-slate-200 px-2 py-2 text-sm"
                required
              />
            </div>
          </div>
          <!-- Remarks full width, textarea -->
          <div>
            <label class="block font-semibold text-sm text-blue-600 mb-1" for="remarks">Remarks:</label>
            <textarea 
              id="remark" 
              formControlName="remark" 
              rows="4"
              class="w-full border-2 border-slate-200 px-2 py-2.5 text-sm resize-y"
              placeholder="Enter remarks here"
            ></textarea>
          </div>
        </div>
      </form>
     </ng-template>
     <ng-template pTemplate="footer">
      <button type="button" class="px-4 py-2 mr-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition" (click)="showDialog=false">
        Close
      </button>
      <button type="submit" (click)="submitForm()" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
        Save
      </button>
    </ng-template>
  </p-dialog>

  <div 
  *ngIf="showIndigenisationPopup" 
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm transition-opacity"
>
  <div class="relative w-full max-w-sm overflow-hidden bg-white shadow-xl rounded-xl border border-gray-200">
    
    <div class="flex items-center justify-between px-4 py-3 bg-gray-50/50 border-b border-gray-100">
      <h3 class="text-md font-bold text-gray-800">Indigenisation Status</h3>
      <button 
        (click)="showIndigenisationPopup = false"
        class="flex items-center justify-center w-7 h-7 text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-full transition-colors"
        type="button">
        <i class="pi pi-times text-xs"></i>
      </button>
    </div>

    <div class="p-4 space-y-4">
      <div class="space-y-1.5">
        <label class="text-xs font-bold uppercase tracking-wider text-gray-500 block">Select Status</label>
        <select 
          class="block w-full h-9 border border-gray-300 rounded-md bg-gray-50 px-3 py-1 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition"
          [(ngModel)]="selectedIndigenisation"
        >
          <option [ngValue]="null" disabled>Select Indigenisation</option>
          <option *ngFor="let opt of indigenisationOptions" [ngValue]="opt">{{ opt.label }}</option>
        </select>
      </div>

      <div *ngIf="selectedIndigenisation?.value === 'working'" class="space-y-1.5 animate-in fade-in slide-in-from-top-2 duration-200">
        <label class="text-xs font-bold uppercase tracking-wider text-gray-500 block">Completion Date</label>
        <input 
          type="date" 
          class="block w-full h-9 border border-gray-300 rounded-md bg-gray-50 px-3 py-1 text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition"
          [(ngModel)]="workingCompletionDate"
        />
      </div>
    </div>

    <div class="flex items-center justify-end gap-2 px-4 py-3 bg-gray-50/50 border-t border-gray-100">
      <button 
        type="button"
        class="px-3 py-1.5 text-xs font-semibold text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 active:scale-95 transition-all shadow-sm"
        (click)="showIndigenisationPopup = false">
        Cancel
      </button>
      <button 
        type="button"
        class="px-4 py-1.5 text-xs font-bold text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95 transition-all shadow-sm"
        (click)="onIndigenisationSubmit()"
        [disabled]="selectedIndigenisation?.value === 'working' && !workingCompletionDate">
        Save Changes
      </button>
    </div>
  </div>
</div>